import React from 'react'
import { SvgIcon } from '@mui/material';

export default function UserViewedIcon(props) {
  return (
    <SvgIcon
      x="0px"
      y="0px"
      viewBox="0 0 120 120"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fontSize="inherit"
      {...props}
    >
      <g fill="none">
        <path
          d="M62.5834 27.5419C59.0834 24.8752 54.75 23.3335 50 23.3335C38.5 23.3335 29.1667 32.6668 29.1667 44.1668C29.1667 55.6668 38.5 65.0002 50 65.0002C61.5 65.0002 70.8333 55.6668 70.8333 44.1668"
          stroke="currentColor"
          strokeWidth="6.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2082 106.667C14.2082 90.5417 30.25 77.5 50 77.5"
          stroke="currentColor"
          strokeWidth="6.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M75.8334 104.167C83.1972 104.167 89.1668 98.1972 89.1668 90.8334C89.1668 83.4696 83.1972 77.5 75.8334 77.5C68.4696 77.5 62.5 83.4696 62.5 90.8334C62.5 98.1972 68.4696 104.167 75.8334 104.167Z"
          stroke="currentColor"
          strokeWidth="6.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M91.6667 106.667L87.5 102.5"
          stroke="currentColor"
          strokeWidth="6.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M246.875 4.0886H245.088L244.759 5H244.194L245.676 0.92516H246.293L247.769 5H247.205L246.875 4.0886ZM246.722 3.65348L245.982 1.58372L245.241 3.65348H246.722ZM248.215 3.37712C248.215 3.04784 248.282 2.75972 248.415 2.51276C248.548 2.26188 248.73 2.06784 248.962 1.93064C249.197 1.79344 249.46 1.72484 249.75 1.72484C250.001 1.72484 250.234 1.78364 250.449 1.90124C250.665 2.01492 250.83 2.16584 250.943 2.354V0.6488H251.484V5H250.943V4.39436C250.837 4.58644 250.681 4.7452 250.473 4.87064C250.265 4.99216 250.022 5.05292 249.744 5.05292C249.458 5.05292 249.197 4.98236 248.962 4.84124C248.73 4.70012 248.548 4.50216 248.415 4.24736C248.282 3.99256 248.215 3.70248 248.215 3.37712ZM250.943 3.383C250.943 3.13996 250.894 2.92828 250.796 2.74796C250.698 2.56764 250.565 2.43044 250.396 2.33636C250.232 2.23836 250.05 2.18936 249.85 2.18936C249.65 2.18936 249.467 2.2364 249.303 2.33048C249.138 2.42456 249.007 2.56176 248.909 2.74208C248.811 2.9224 248.762 3.13408 248.762 3.37712C248.762 3.62408 248.811 3.83968 248.909 4.02392C249.007 4.20424 249.138 4.3434 249.303 4.4414C249.467 4.53548 249.65 4.58252 249.85 4.58252C250.05 4.58252 250.232 4.53548 250.396 4.4414C250.565 4.3434 250.698 4.20424 250.796 4.02392C250.894 3.83968 250.943 3.62604 250.943 3.383ZM252.189 3.37712C252.189 3.04784 252.255 2.75972 252.388 2.51276C252.522 2.26188 252.704 2.06784 252.935 1.93064C253.171 1.79344 253.433 1.72484 253.723 1.72484C253.974 1.72484 254.207 1.78364 254.423 1.90124C254.639 2.01492 254.803 2.16584 254.917 2.354V0.6488H255.458V5H254.917V4.39436C254.811 4.58644 254.654 4.7452 254.446 4.87064C254.239 4.99216 253.996 5.05292 253.717 5.05292C253.431 5.05292 253.171 4.98236 252.935 4.84124C252.704 4.70012 252.522 4.50216 252.388 4.24736C252.255 3.99256 252.189 3.70248 252.189 3.37712ZM254.917 3.383C254.917 3.13996 254.868 2.92828 254.77 2.74796C254.672 2.56764 254.539 2.43044 254.37 2.33636C254.205 2.23836 254.023 2.18936 253.823 2.18936C253.623 2.18936 253.441 2.2364 253.276 2.33048C253.112 2.42456 252.98 2.56176 252.882 2.74208C252.784 2.9224 252.735 3.13408 252.735 3.37712C252.735 3.62408 252.784 3.83968 252.882 4.02392C252.98 4.20424 253.112 4.3434 253.276 4.4414C253.441 4.53548 253.623 4.58252 253.823 4.58252C254.023 4.58252 254.205 4.53548 254.37 4.4414C254.539 4.3434 254.672 4.20424 254.77 4.02392C254.868 3.83968 254.917 3.62604 254.917 3.383Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
